import { openModal } from '@kcd/app-interface/dist/web2app';
import { trackEvent } from '@kcd/event-tracker';

import { useMembershipStatus } from '../../hooks/useMembershipStatus';

import {
  MypageBonuspackNudgeImg,
  MypageMembershipNudgeImg,
  MypageTrialNudgeImg,
} from '~/assets/img/cashnote-membership/nudge';

export function MypageMembershipNudge() {
  const {
    isMembershipSubscribeServiceAvailable,
    isTrialAvailable,
    isAvailableToSubscribe,
    isAvailableToSubscribeBonusPack,
    getRegisterMembershipUrl,
  } = useMembershipStatus();

  const onClickSubscribe = () => {
    const nudgeType = (() => {
      if (isTrialAvailable) {
        return 'plus_membership_free';
      }

      if (isAvailableToSubscribe) {
        return 'plus_membership';
      }

      if (isAvailableToSubscribeBonusPack) {
        return 'lucky_bonus_pack';
      }

      return '';
    })();

    const registerUrl = getRegisterMembershipUrl();

    trackEvent('clicked banner in 마켓/마이페이지', {
      membership_nudge_type: nudgeType,
    });

    if (registerUrl) {
      openModal({
        url: registerUrl,
      });
    }
  };

  const nudgeContent = (() => {
    if (isTrialAvailable) {
      return <img src={MypageTrialNudgeImg.src} alt="멤버십 전용 혜택" />;
    }

    if (isAvailableToSubscribe) {
      return <img src={MypageMembershipNudgeImg.src} alt="멤버십 전용 혜택" />;
    }

    if (isAvailableToSubscribeBonusPack) {
      return <img src={MypageBonuspackNudgeImg.src} alt="멤버십 전용 혜택" />;
    }

    return null;
  })();

  if (!isMembershipSubscribeServiceAvailable || !nudgeContent) return <></>;

  return (
    <button className="px-20 pb-16" type="button" onClick={onClickSubscribe}>
      {nudgeContent}
    </button>
  );
}
